(()=>{
  const drawer=document.querySelector('[data-cart-drawer]');
  const backdrop=document.querySelector('[data-cart-drawer-backdrop]');
  if(!drawer||!backdrop)return;
  const body=drawer.querySelector('[data-cart-drawer-body]');
  const footer=drawer.querySelector('[data-cart-drawer-footer]');
  const subtotal=drawer.querySelector('[data-cart-subtotal]');
  const message=drawer.querySelector('[data-cart-shipping-message]');
  const progress=drawer.querySelector('[data-cart-shipping-progress]');
  const threshold=7000;
  let lastFocus=null;
  const money=cents=>window.cmMoney?window.cmMoney(cents):('$'+(cents/100).toFixed(2));
  const esc=s=>String(s||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const updateCount=cart=>document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
  const shipping=cart=>{
    const cents=cart.total_price||0;
    const pct=Math.max(0,Math.min(100,(cents/threshold)*100));
    if(progress)progress.style.width=pct+'%';
    if(!message)return;
    if(!cart.item_count)message.textContent='Free Standard Shipping on orders $70+';
    else if(cents>=threshold)message.textContent='You unlocked FREE Standard Shipping 🎉';
    else message.textContent=`You're ${money(threshold-cents)} away from FREE Standard Shipping`;
  };
  const render=cart=>{
    updateCount(cart);shipping(cart);
    if(subtotal)subtotal.textContent=money(cart.total_price||0);
    if(!cart.item_count){
      footer.hidden=true;
      body.innerHTML='<div class="cm-drawer__empty"><strong>Your cart is waiting.</strong><p>Put your cat in Creature Mode.</p><button class="cm-btn cm-btn--primary" type="button" data-cart-drawer-close>Shop the costume</button></div>';
      return;
    }
    footer.hidden=false;
    body.innerHTML=cart.items.map((item,index)=>{
      const variant=item.variant_title&&item.variant_title!=='Default Title'?`<div class="cm-drawer__variant">${esc(item.variant_title)}</div>`:'';
      const image=item.image?`<a class="cm-drawer__image" href="${esc(item.url)}"><img src="${esc(item.image)}" alt="${esc(item.product_title)}" loading="lazy"></a>`:'<div class="cm-drawer__image"></div>';
      return `<div class="cm-drawer__item" data-cart-line="${index+1}">${image}<div><div class="cm-drawer__item-head"><div><a class="cm-drawer__item-title" href="${esc(item.url)}">${esc(item.product_title)}</a>${variant}</div><span class="cm-drawer__line-price">${money(item.final_line_price)}</span></div><div class="cm-drawer__item-bottom"><div class="cm-drawer__qty" aria-label="Quantity"><button type="button" data-cart-change="minus" data-line="${index+1}" data-quantity="${item.quantity}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="plus" data-line="${index+1}" data-quantity="${item.quantity}" aria-label="Increase quantity">+</button></div><button class="cm-drawer__remove" type="button" data-cart-remove data-line="${index+1}">Remove</button></div></div></div>`;
    }).join('');
  };
  const getCart=()=>fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error('cart');return r.json()});
  const refresh=()=>getCart().then(render);
  const open=async()=>{
    lastFocus=document.activeElement;
    backdrop.hidden=false;
    requestAnimationFrame(()=>{backdrop.classList.add('is-open');drawer.classList.add('is-open')});
    drawer.setAttribute('aria-hidden','false');document.body.classList.add('cm-drawer-open');
    try{await refresh()}catch(e){body.innerHTML='<div class="cm-drawer__empty"><strong>Could not load cart.</strong><p>Please try again or open the cart page.</p><a class="cm-btn cm-btn--primary" href="/cart">View cart</a></div>'}
    drawer.querySelector('[data-cart-drawer-close]')?.focus();
  };
  const close=()=>{
    drawer.classList.remove('is-open');backdrop.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('cm-drawer-open');
    setTimeout(()=>{backdrop.hidden=true},240);lastFocus?.focus?.();
  };
  const change=async(line,quantity)=>{
    body.setAttribute('aria-busy','true');
    try{const res=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity})});if(!res.ok)throw new Error('change');render(await res.json())}finally{body.removeAttribute('aria-busy')}
  };
  document.addEventListener('click',e=>{
    const opener=e.target.closest('[data-cart-drawer-open]');if(opener){e.preventDefault();open();return}
    if(e.target.closest('[data-cart-drawer-close]')||e.target===backdrop){close();return}
    const q=e.target.closest('[data-cart-change]');if(q){const current=parseInt(q.dataset.quantity,10)||1;change(parseInt(q.dataset.line,10),q.dataset.cartChange==='plus'?current+1:Math.max(0,current-1));return}
    const remove=e.target.closest('[data-cart-remove]');if(remove){change(parseInt(remove.dataset.line,10),0)}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer.classList.contains('is-open'))close()});
  window.CritterModeCart={open,close,refresh,render};
  document.addEventListener('crittermode:cart-updated',e=>{if(e.detail?.cart)render(e.detail.cart);else refresh();if(e.detail?.open)open()});
})();